export const aulasVivas = [{
        name: "Aula MPK. ",
        description: "Conoce nuestra pedagogía a través de los videos que han creado desde el Colegio Monte Tabor y Nazaret (Guayaquil, Ecuador)",
    },
    {
        name: "Aula MTS. ",
        description: "Modelo educativo orgánico. Colegio Monte Tabor Schoenstatt, Madrid. Describiremos parte de las claves de nuestro modelo educativo y didácticas propias.",
    },
    {
        name: "Aula “Efecto Dominó”. ",
        description: "Procesos de transformación. Evaluación formativa. MTS. Madrid. Describiremos el proceso de mejora del sistema de evaluación en el que estamos inmersos desde hace un par de años.",
    },
    {
        name: "Aula CEU. ",
        description: "Psicomotricidad en Educación Infantil. CEU San Chinarro, Madrid. La psicomotricidad, en infantil, puede ser el eje de todo el aprendizaje.",
    },
    {
        name: "Aula Anaya.",
        description: " Herramientas Digitales al servicio del aprendizaje.",
    },
    {
        name: "Aula Identitas. ",
        description: "Formación",
    },
    {
        name: "Aula Arquitectura Orgánica.",
        description: "Pendiente de confirmación. A través del concepto orgánico en los arquitectónico, podemos comprender qué de interesante tiene una educación orgánica. Además reflexionaremos sobre la importancia del espacio como herramienta educativa.",
    },
    {
        name: "Aula Experiencia de Aprendizajes Cooperativos",
        description: "(San José de Chicureo, Chile) A confirmar.",
    },
    {
        name: "Aula Daccapo:",
        description: "Teatro y comunicación. ",
    },
];